const anetDimebar = "mcc31d68ed_anetDimebar";
const anetDimebarAbs = anetDimebar + " " + "mcc31d68ed_anetDimebarAbs";
const wrapper = "mcc31d68ed_wrapper";
const siteNav = "mcc31d68ed_siteNav";
const primaryNav = "mcc31d68ed_primaryNav";
const supportInfo = "mcc31d68ed_supportInfo";
const downloadBtn = "mcc31d68ed_downloadBtn";
const anetLogo = "mcc31d68ed_anetLogo";
const langSelectBar = "mcc31d68ed_langSelectBar";
const currentLang = "mcc31d68ed_currentLang";
export default {
    anetDimebar,
anetDimebarAbs,
wrapper,
siteNav,
primaryNav,
supportInfo,
downloadBtn,
anetLogo,
langSelectBar,
currentLang
};

export {
    anetDimebar,
anetDimebarAbs,
wrapper,
siteNav,
primaryNav,
supportInfo,
downloadBtn,
anetLogo,
langSelectBar,
currentLang
};